import { Injectable } from '@angular/core';
import { AlertModalService } from '../component/alertmodal/alertmodal.service';
import { AlertBlockService } from '../component/alertblock/alertblock.service';
import { Error, ModalType } from '../models/error/error';
var AlertService = /** @class */ (function () {
    function AlertService(alertModalService, alertBlockService) {
        this.alertModalService = alertModalService;
        this.alertBlockService = alertBlockService;
    }
    AlertService.prototype.clear = function () {
        this.alertBlockService.alert(new Error());
    };
    AlertService.prototype.alert = function (error) {
        error.type = ModalType.error;
        this.alertModalService.open({
            buttons: [{
                    class: 'ok',
                    event: error.code ? 'Err' + error.code : 'ok',
                    caption: 'OK'
                }]
        }, error);
        this.alertBlockService.alert(error);
    };
    AlertService.prototype.reload = function () {
        this.alertModalService.reload();
    };
    AlertService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AlertService.ctorParameters = function () { return [
        { type: AlertModalService },
        { type: AlertBlockService }
    ]; };
    return AlertService;
}());
export { AlertService };
//# sourceMappingURL=alert.service.js.map